<template>
  <main v-if="true" id="customer-detail1-main" :class="{'boxPadding': isBox}">
    <customer-info 
    :custDieStatus="custDie"
    :loading="loading_1"
    :runEnv="runEnv"
    ref="cust_info" />
    <tab-header :current="currentTab"/>
    <div class="tab-content">
      <div class="container-fluid">
        <div class="tab-pane active show">
          <!-- SocialData -->
          <div class="row with-divider">
            <div class="col-7">
              <!-- <hr> -->
              <!-- IAA -->
              <div v-if="CustInfo.ID !== '' && CustInfo.relation &&
              (CustInfo.relation.source1_pltn == '1' || CustInfo.relation.source1_pltn == '2' || CustInfo.relation.source1_pltn == '3')">
                <h4 class="text-green">
                  <a 
                  @click.prevent="openAddressModal()" 
                  class="btn btn-default btn-sm float-right m-0">看更多</a>
                  聯絡資訊(公司提供)
                </h4>
                <div class="row" :class="{'section-loading': loading_2}">
                  <div class="col-6">
                    <div class="item row">
                      <div class="col-4 label">手機</div>
                      <div class="col-8 text">{{custIaa.mobile | emptyField}}</div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="item row">
                    </div>
                  </div>
                  <div class="col-6">
                      <div class="item row">
                        <div class="col-4 label">住家電話</div>
                        <div class="col-8 text">{{custIaa.homeTel | emptyField}}</div>
                      </div>
                  </div>
                  <div class="col-6">
                      <div class="item row">
                        <div class="col-4 label">公司電話</div>
                        <div class="col-8 text">{{custIaa.corpTel | emptyField}}</div>
                      </div>
                  </div>
                  <div class="col-12">
                      <div class="item row">
                        <div class="col-2 label">收費地址</div>
                        <div class="col-10 text">
                          <span v-if="!custIaa.address || custIaa.address==''">— —</span>
                            <a class="link text-underline"
                            target="_blank"
                            :href="`https://www.google.com/maps/place/${custIaa.address}`"
                            v-else>
                              {{custIaa.address | addressFormat | emptyField}}
                            </a>
                        </div>
                      </div>
                      <div class="item row">
                        <div class="col-2 label">Email</div>
                        <div class="col-10 text" >{{custIaa.email | emptyField}}</div>
                      </div>
                  </div>
                </div>
                <hr>
              </div>
              <div v-else></div>  <!-- 如果客戶無 ID 不顯示資訊 --> 


              <div v-if="CustInfo.ID === ''"></div>
              <div v-else>
                <h4 class="text-green">
                <a 
                @click.prevent="panelOpen('RejectMarketingModalOpen')"
                class="btn btn-default btn-sm float-right m-0">看說明</a>
                客戶申請拒絕行銷
                </h4>
                <div v-if="rejectCathay" class="row px-5" style="min-height: 35px;">已申請：拒絕國泰人壽行銷</div>
                <div v-else class="row px-5" style="min-height: 35px;">查無申請紀錄</div>
                <hr>
              </div>



              <a role="button" @click="panelOpen('basicInfoOpen')" class="btn btn-default btn-sm float-right m-0">
                  <i class="icon-edit">編輯</i>
                </a>
             <h4 class="text-green mt-0">
                基本資料
              </h4>
              <div class="row" 
              :class="{'section-loading': loading_1}">
                <div class="col-6">
                  <div class="item row">
                    <div class="col-4 label">公司往來</div>
                    <div class="col-8 text">{{custPersonalInfo.remark | emptyField}}</div>
                  </div>
                  <div class="item row">
                    <div class="col-4 label">傳真</div>
                    <div class="col-8 text">{{getFax(custPersonalInfo.fax) | emptyField}}</div>
                  </div>
                  <div class="item row">
                    <div class="col-4 label">職業</div>
                    <div class="col-8 text" v-if='custPersonalInfo.career_box'>第{{custPersonalInfo.job_cat}}類{{custPersonalInfo.job_name}}</div>
                    <div class="col-8 text" v-else>{{custPersonalInfo.career | emptyField}}</div>
                  </div>
                  <div class="item row">
                    <div class="col-4 label">服務單位</div>
                    <div class="col-8 text">{{custPersonalInfo.agency | emptyField}}</div>
                  </div>
                  <div class="item row">
                    <div class="col-4 label">婚姻</div>
                    <div class="col-8 text">{{custPersonalInfo.marriage | emptyField}}</div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="item row">
                    <div class="col-4 label">客戶關係</div>
                    <div class="col-8 text">{{custPersonalInfo.relatepltn | emptyField}} {{isnocontractrelation}}</div>
                  </div>
                  <div v-if="CustInfo.ID"  class="item row" style="justify-content:center;">
                    <a class="btn btn-default btn-sm"  @click="checkNotice()">拜訪聯繫函</a>                    
                  </div>
                  <div class="item row">
                    <div class="col-4 label">Email</div>
                    <div class="col-8 text" style="word-break: break-all;">{{custPersonalInfo.email | emptyField}}</div>
                  </div>
                  <div class="item row">
                    <div class="col-4 label">介紹人</div>
                    <div class="col-8 text">
                      <a
                      v-on:click="routeToCustDetail(custPersonalInfo.introducerId, custPersonalInfo.introducer)"
                      class="link text-underline">
                        {{custPersonalInfo.introducer}}
                      </a>
                    </div>
                  </div>
                  <div class="item row">
                    <div class="col-4 label">學歷</div>
                    <div class="col-8 text">{{custPersonalInfo.education | emptyField}}</div>
                  </div>
                  <div class="item row">
                    <div class="col-4 label">居住狀況</div>
                    <div class="col-8 text">{{custPersonalInfo.housing_status | emptyField}}</div>
                  </div>
                </div>
              </div>



 
              <div :class="{'section-loading': loading_1}">
                <!-- <a @click="panelOpen('financialOpen')" role="button" class="btn btn-default btn-sm float-right m-0">
                    <i class="icon-edit">編輯</i>
                  </a> -->
                <h4 class="text-green">
                  財務狀況
                </h4>
                <div>
                  <div class="row">
                    <div class="col-6">
                      <div class="item row">
                        <div class="col-5 label">家庭年收入</div>
                        <div class="col-7 text">
                          {{custFinancial.household_income | emptyField}}
                        </div>
                      </div>
                      <div class="item row">
                        <div class="col-5 label">個人年所得</div>
                        <div class="col-7 text">
                          {{custFinancial.personal_income | emptyField}}
                        </div>
                      </div>
                      <div class="item row">
                        <div class="col-5 label">月平均投資</div>
                        <div class="col-7 text">
                          {{custFinancial.monthly_invest | emptyField}}
                        </div>
                      </div>
                      <div class="item row">
                        <div class="col-5 label">理財工具</div>
                        <div class="col-7 text">
                          {{custFinancial.finance_tool + '' | emptyField}}
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="item row">
                        <div class="col-4 label">房貸金額</div>
                        <div class="col-8 text">
                          {{custFinancial.houseloan | emptyField}}
                          <span v-if="custFinancial.houseloan">萬</span>
                        </div>
                      </div>
                      <div class="item row">
                        <div class="col-4 label">住宅權屬</div>
                        <div class="col-8 text">
                          {{custFinancial.housing | emptyField}}
                        </div>
                      </div>
                      <div class="item row">
                        <div class="col-4 label">交通工具</div>
                        <div class="col-8 text">
                          {{custFinancial.vehicle | emptyField}}
                        </div>
                      </div>
                      <div class="item row">
                        <div class="col-4 label">風險屬性
                          <a style="cursor: pointer;" @click="openRiskAttributesModal">
                            <img :src="`${BaseUrl}assets/tagicon/question-mark.png`" width="15" />
                          </a>  
                        </div>
                        <div class="col-8 text" v-html="messageWithBr">
                        </div>
                      </div>
                      <div class="item row">
                        <div class="col-4 label">(有效期限)
                        </div>
                        <div class="col-8 text">
                          {{eft_date ? eft_date:"— —"}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <a role="button" @click="panelOpen('memoModalOpen')" class="btn btn-default btn-sm float-right m-0">
                    <i class="icon-edit">編輯</i>
                  </a> -->
                <h4 class="text-green mt-0">
                  備註
                </h4>
                <div class="row px-5" style="min-height: 100px; word-break: break-word; overflow-wrap: break-word;" v-html="memoData.memohtml">
                </div>
                <!--<hr>
                 <h4 class="text-green">行銷方式</h4>
                <div class="row px-5" 
                :class="{
                  'section-loading': loading_1
                }">
                  <div class="col-4 sale-item">
                    <i :class="custDecline.indexOf(1) > -1 ? `icon-close text-red`:`icon-check text-green`"></i>
                    <span class="text">簡訊行銷</span>
                  </div>
                  <div class="col-4 sale-item">
                    <i :class="custDecline.indexOf(2) > -1 ? `icon-close text-red`:`icon-check text-green`"></i>
                    <span class="text">電話行銷</span>
                  </div>
                  <div class="col-4 sale-item">
                    <i :class="custDecline.indexOf(3) > -1 ? `icon-close text-red`:`icon-check text-green`"></i>
                    <span class="text">Email行銷</span>
                  </div>
                  <div class="col-4 sale-item">
                    <i :class="custDecline.indexOf(4) > -1 ? `icon-close text-red`:`icon-check text-green`"></i>
                    <span class="text">郵寄行銷</span>
                  </div>
                  <div class="col-8 sale-item">
                    <i :class="custDecline.indexOf(5) > -1 ? `icon-close text-red`:`icon-check text-green`"></i>
                    <span class="text">業務人員行銷(非經手或服務人員)</span>
                  </div>
                  <div class="col-8 sale-item" v-if="custDecline.indexOf(7) > -1">
                    <i :class="custDecline.indexOf(7) > -1 ? `icon-check text-green`:`icon-close text-red`"></i>
                    <span class="text">此客戶拒絕｢產險｣共同行銷</span>
                  </div>
                </div> -->
                <hr>
              </div>
              
            </div>
            <div class="col-5" v-if="CustInfo.ID === ''">
              <h4 class="text-green">
                <a class="btn btn-default btn-sm float-right m-0"
                role="button"
                @click="panelOpen('confirmGroupModalOpen')">
                  <i class="icon-edit">編輯</i>
                </a>
                群組
              </h4>
              <div class="button-grid two-items px-0 pb-0"
              v-if="grpsOfCust && grpsOfCust.length">
                <a class="btn btn-border-green"
                @click="selectGroup(btn)"
                v-show="groupCollapse || (!groupCollapse && bid < 6)"
                v-for="(btn, bid) in grpsOfCust"
                :key="`group-item-${bid}`">
                  {{btn.grp_name}}
                </a>
              </div>
              <div class="mt-3" v-else>
                <div class="gray-block">目前不屬於任何群組</div>
              </div>
              <div v-if="grpsOfCust && grpsOfCust.length && grpsOfCust.length > 6">
                <a
                class="link text-underline collapse-item"
                v-if="!groupCollapse"
                @click.stop.prevent="groupCollapse = true">
                  顯示更多 <i class="icon-collapse_down"></i>
                </a>
                <a class="link text-underline collapse-item"
                v-else
                @click.stop.prevent="groupCollapse = false">
                  收合顯示 <i class="icon-collapse_up"></i>
                </a>
              </div>
              <!-- 提醒事項區塊 -->
              <h4 class="text-green">提醒事項</h4>
              <div class="button-grid two-items px-0 pb-0" :class="{'section-loading': loading_5}" v-if="attention && attention.length">
                <a
                  class="btn btn-border-green"
                  @click="openAttentionModal(data)"
                  v-for="(data, bid) in attention"
                  :key="`attention-item-${bid}`"
                >{{data.name}}</a>
              </div>         
            </div>
            <!-- 如果客戶無 ID 不顯示資訊 -->
            <div class="col-5" v-else>
              <!-- 泰好客 -->
              <div v-if="is_open_mkt_type == 'Y'">
                <span class="cathay-cust-info-title text-green">
                  泰好客
                  <a style="cursor: pointer;" @click="openCathayCustInfoModal">
                    <img :src="`${BaseUrl}assets/tagicon/question-mark.png`" width="15" />
                  </a>
                </span>
                <span class="cathay-cust-info-title-circle bg-green1 mr-1">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="cathay-cust-info-title-circle bg-orange1">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <label class="cathay-cust-info-label">高促約潛力</label>
                <span class="cathay-cust-info-title-circle bg-green2 mr-1">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="cathay-cust-info-title-circle bg-orange2">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <label class="cathay-cust-info-label">中高促約潛力</label>
                <div :class="{'section-loading': loading_3}">
                  <div v-if="custSource1 && custSource1 != '0'">
                    <table class="table-info">
                      <tbody>
                        <tr>
                          <td>
                            <span
                              :class="cathayCustInfo.hos_mkt_level ? cathayCustInfo.hos_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                            >住</span>
                          </td>
                          <td>
                            <span
                              :class="cathayCustInfo.sur_mkt_level ? cathayCustInfo.sur_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                            >手</span>
                          </td>
                          <td>
                            <span
                              :class="cathayCustInfo.rei_mkt_level ? cathayCustInfo.rei_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                            >實</span>
                          </td>
                          <td>
                            <span
                              :class="cathayCustInfo.acc_mkt_level ? cathayCustInfo.acc_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                            >意</span>
                          </td> 
                          <td>
                            <span
                              :class="cathayCustInfo.dd_mkt_level ? cathayCustInfo.dd_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                            >重</span>
                          </td>
                          <td>
                            <span
                              :class="cathayCustInfo.ltc_mkt_level ? cathayCustInfo.ltc_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                            >長</span>
                          </td>
                          <td>
                            <span
                              :class="cathayCustInfo.life_mkt_level ? cathayCustInfo.life_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                            >壽</span>
                          </td>
                          <td>
                            <span
                              :class="cathayCustInfo.sav_mkt_level ? cathayCustInfo.sav_mkt_level == '1' ? 'bg-orange1' : 'bg-orange2' : 'bg-gray'"
                            >儲</span>
                          </td>
                          <td>
                            <span
                              :class="cathayCustInfo.inv_mkt_level ? cathayCustInfo.inv_mkt_level == '1' ? 'bg-orange1' : 'bg-orange2' : 'bg-gray'"
                            >投</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="mt-3" v-else>
                    <div class="gray-block">目前無泰好客資訊</div>
                  </div>
                </div>
              </div>
              <!-- 客戶標籤 -->
              <h4 class="text-green">
                客戶標籤
                <a v-if="custTag && custTag.length"
                style="cursor: pointer;"
                  @click="openTagInfoModal"
                >
                  <img :src="`${BaseUrl}assets/tagicon/question-mark.png`" width="15">
                </a>
              </h4>
              <div :class="{'section-loading': loading_3}">
                <div class="button-grid two-items px-0 pb-0"
                v-if="custTag && custTag.length">
                  <a class="btn btn-border-green"
                  @click="openCustTagModal(data)"
                  v-show="tagCollapse || (!tagCollapse && bid < 6)"
                  v-for="(data, bid) in custTag"
                  :key="`tag-item-${bid}`">
                    {{data.tag_show_name ? data.tag_show_name : data.tag_name}}
                    <img v-if="data.ishot=='1'" :src="`${BaseUrl}assets/tagicon/crown.png`" width="20">
                    <img v-else-if="data.ishot=='2'" :src="`${BaseUrl}assets/tagicon/new.png`" width="30">
                  </a>
                </div>
                <div class="mt-3" v-else>
                  <div class="gray-block">目前無符合標籤</div>
                </div>
                <div v-if="custTag && custTag.length && custTag.length > 6">
                  <a
                  class="link text-underline collapse-item"
                  v-if="!tagCollapse"
                  @click.stop.prevent="tagCollapse = true">
                    顯示更多 <i class="icon-collapse_down"></i>
                  </a>
                  <a class="link text-underline collapse-item"
                  v-else
                  @click.stop.prevent="tagCollapse = false">
                    收合顯示 <i class="icon-collapse_up"></i>
                  </a>
                </div>
              </div>
              <!-- 名單專區 -->
              <h4 class="text-green">
                名單專區
              </h4>
              <div class="button-grid two-items px-0 pb-0"
              v-if="custCategory && custCategory.length">
                <a class="btn btn-border-green"
                @click="routeToCustCategory(btn.cate_serno, btn.category)"
                v-show="categoryCollapse || (!categoryCollapse && bid < 6)"
                v-for="(btn, bid) in custCategory"
                :key="`group-item-${bid}`">
                  {{btn.category_name}}
                </a>
              </div>
              <div class="mt-3" v-else>
                <div class="gray-block">目前無符合名單</div>
              </div>
              <div v-if="custCategory && custCategory.length && custCategory.length > 6">
                <a
                class="link text-underline collapse-item"
                v-if="!categoryCollapse"
                @click.stop.prevent="categoryCollapse = true">
                  顯示更多 <i class="icon-collapse_down"></i>
                </a>
                <a class="link text-underline collapse-item"
                v-else
                @click.stop.prevent="categoryCollapse = false">
                  收合顯示 <i class="icon-collapse_up"></i>
                </a>
              </div>
              <!-- 提醒事項區塊 -->
              <h4 class="text-green">提醒事項</h4>
              <div class="button-grid two-items px-0 pb-0" :class="{'section-loading': loading_4}" v-if="attention && attention.length">
                <a
                  class="btn btn-border-green"
                  @click="openAttentionModal(data)"
                  v-show="attentionCollapse || (!attentionCollapse && bid < 6)"
                  v-for="(data, bid) in attention"
                  :key="`attention-item-${bid}`"
                >{{data.name}}</a>
              </div>
              <div v-if="attention && attention.length && attention.length > 6">
                <a
                  class="link text-underline collapse-item"
                  v-if="!attentionCollapse"
                  @click.stop.prevent="attentionCollapse = true"
                >
                  顯示更多
                  <i class="icon-collapse_down"></i>
                </a>
                <a
                  class="link text-underline collapse-item"
                  v-else
                  @click.stop.prevent="attentionCollapse = false"
                >
                  收合顯示
                  <i class="icon-collapse_up"></i>
                </a>
              </div>
              <!-- 申辦項目區塊 -->
              <h4 class="text-green">申辦項目</h4>
              <div class="button-grid cards two-card px-0 pb-0"
                :class="{
                  'section-loading': loading_3
                }">
                <a class="card text-center no-shadow"
                v-for="(item, index) in serviceItems"
                :class="(item.status===0 || item.status==='N') && !isBoxLinkNegativeService(item.id) ? 'disabled' : ''"
                :key="`notification-item-${index+1}`"
                @click="selectedService=index+1; checkIsOpenServiceModal(item)">
                  <h6 class="m-0">{{item.name}}</h6>

                  <small class="text-orange mt-1"
                  v-if="item.status==1 || item.status==='Y' || item.id==='serviceFITBACK' || item.id==='serviceFACE_STATUS'"
                  :role="item.link==1? 'button': null"
                  :class="{
                    'text-underline': item.link==1? '#': null
                  }">
                    {{ item.positiveMsg }}
                    <span v-if="item.link==1">❯</span>
                  </small>

                  <small class="text-orange mt-1"
                  v-else-if="item.status==='X'"
                  :role="item.link==1? 'button': null"
                  :class="{
                    'text-underline': item.link==1? '#': null
                  }">
                    {{ item.normalMsg }}
                    <span v-if="item.id=='serviceCHANGEONLINE' && item.link==1">❯</span>
                  </small>

                  <small class="text-red text-thin mt-1"
                  v-else-if="item.status==='A'"
                  >
                    {{ item.normalMsg }}
                  </small>

                  <small class="text-red text-thin mt-1"
                  v-else
                  :role="isBoxLinkNegativeService(item.id) ? 'button' : null"
                  :class="{
                    'text-underline': isBoxLinkNegativeService(item.id) ? '#' : null
                  }"
                  >
                    {{ item.negativeMsg }}
                  </small>
                </a>
              </div>
              <!-- <h4 class="text-green mt-0">申辦項目</h4>
              <div class="button-grid cards two-card px-0 pb-0">
                <a class="card text-center no-shadow"
                role="button"
                v-for="(btn, bid) in serviceItems"
                :class="btn.status===0 ? 'disabled': ''"
                :key="`notification-item-${bid}`"
                @click="selectedService=bid; panelOpen('serviceModalOpen')">
                  <h6 class="m-0">{{btn.name}}</h6>
                  <small class="text-orange mt-1"
                  v-if="btn.status!=0"
                  :class="{
                    'text-underline': btn.link
                  }">
                    {{ btn.status }} 
                    <span v-if="!btn.link==false">❯</span>
                  </small>
                  <small class="text-red text-thin mt-1"
                  v-else
                  :class="{
                    'text-underline': btn.link
                  }">
                    尚未申辦{{btn.link}}
                    <span v-if="!btn.link==false">❯</span>
                  </small>
                </a>
              </div> -->

              <!-- <h4 class="text-green">商機專區</h4>
              <div class="button-grid two-items px-0 pb-0"
              v-if="saleNotification.length">
                <a class="btn btn-border-green"
                v-show="saleNotificationCollapse || (!saleNotificationCollapse && bid < 6)"
                v-for="(btn, bid) in saleNotification"
                @click="openBusinessModal(btn)"
                :key="`sale-item-${bid}`">
                  {{btn}}
                </a>
              </div>
              <div class="mt-3" v-else>
                <div class="gray-block">目前沒有任何通知</div>
              </div>
              <div v-if="saleNotification.length && saleNotification.length > 6">
                <a
                class="link text-underline collapse-item"
                v-if="!saleNotificationCollapse"
                @click.stop.prevent="saleNotificationCollapse = true">
                  顯示更多 <i class="icon-collapse_down"></i>
                </a>
                <a class="link text-underline collapse-item"
                v-else
                @click.stop.prevent="saleNotificationCollapse = false">
                  收合顯示 <i class="icon-collapse_up"></i>
                </a>
              </div> -->


              <h4 class="text-green">
                <a class="btn btn-default btn-sm float-right m-0"
                role="button"
                @click="panelOpen('confirmGroupModalOpen')">
                  <i class="icon-edit">編輯</i>
                </a>
                群組
              </h4>
              <div class="button-grid two-items px-0 pb-0"
              v-if="grpsOfCust && grpsOfCust.length">
                <a class="btn btn-border-green"
                @click="selectGroup(btn)"
                v-show="groupCollapse || (!groupCollapse && bid < 6)"
                v-for="(btn, bid) in grpsOfCust"
                :key="`group-item-${bid}`">
                  {{btn.grp_name}}
                </a>
              </div>
              <div class="mt-3" v-else>
                <div class="gray-block">目前不屬於任何群組</div>
              </div>
              <div v-if="grpsOfCust && grpsOfCust.length && grpsOfCust.length > 6">
                <a
                class="link text-underline collapse-item"
                v-if="!groupCollapse"
                @click.stop.prevent="groupCollapse = true">
                  顯示更多 <i class="icon-collapse_down"></i>
                </a>
                <a class="link text-underline collapse-item"
                v-else
                @click.stop.prevent="groupCollapse = false">
                  收合顯示 <i class="icon-collapse_up"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <!-- 整合地址查詢 -->
    <index-integrated-address-modal
      :open="IndexIntegratedAddressModalOpen"
      :address-data='addressData'
      @close="panelClose('IndexIntegratedAddressModalOpen')"
    />

    <reject-marketing-modal
      :open="RejectMarketingModalOpen"
      @close="panelClose('RejectMarketingModalOpen')"
    />

    <add-to-group-modal
    :open="addToGroupOpen"
    :custName="CustInfo.name"
    :grpsOfAgnt="grpsOfAgnt"
    :grpsOfCust="grpsOfCust"
    @submit="addToGrpSubmit"
    @close="panelClose('addToGroupOpen')"/>
    
    <vip-modal
    :open="vipModalOpen"
    @close="panelClose('vipModalOpen')"/>
    
    <service-modal
    :type="selectedService"
    :open="serviceModalOpen"
    :instance="selectedServiceInstance"
    :mmlUrl="mmlUrl"
    :fbMetaUrl="fbMetaUrl"
    :bankText="bankText"
    :bankUrl="bankUrl"
    :credentialsText="credentialsText"
    :credentialsUrl="credentialsUrl"
    :cwpText="cwpText"
    :cwpUrl="cwpUrl"
    @close="panelClose('serviceModalOpen')"/>
    
    <group-member-modal
    :open="groupModalOpen"
    :group="selectedGroup"
    :memberList="grpMemList"
    @selectMem="reGetCustDetail"
    @close="panelClose('groupModalOpen')"
    />

    <!-- <social-data-modal
    :open="socialDataOpen"
    :inputs='custPersonalInfo'
    :custInfo="$store.state.custInfo"
    @submit="dataSubmit"
    @close="panelClose('socialDataOpen')"/> -->

    <basic-info-modal
    :open="basicInfoOpen"
    :socialData='custPersonalInfo'
    :financialData='custFinancial'
    :memoData="memoData"
    :custInfo="$store.state.custInfo"
    @submit="dataSubmit"
    @close="panelClose('basicInfoOpen')"/>

    <no-change-notice
    :open="NoChangeNoticeOpen"
    :inputs='custPersonalInfo'
    @submit="dataSubmit"
    @close="panelClose('NoChangeNoticeOpen')"/>

    <change-notice-type
    :open="ChangeNoticeTypeOpen"
    :inputs='custPersonalInfo'
    @submit="dataSubmit"
    @selectType="selectType"
    @close="panelClose('ChangeNoticeTypeOpen')"/>

    <ContactLetter
    :open="ContactLetterOpen"
    :formData="contactLetterData"
    :custAddress="CustInfo.address"
    @close="panelClose('ContactLetterOpen')"/>

    <!-- 專函 -->
    <send-modal 
    :open="sendModalOpen"
    :cust-data="sendCustData"
    :sendtype="sendType"  
    @close="panelClose('sendModalOpen')" />
    
    <!-- <financial-modal
    :open="financialOpen"
    :inputs='custFinancial'
    @submit="financialSubmit"
    @close="panelClose('financialOpen')"/> -->

    <iaa-report-modal
    :open="iaaReportOpen"
    :hasData= isFound
    @submit="submitIAAReport"
    @close="iaaReportColse"/>

    <iaa-check-modal
    :open="iaaCheckOpen"
    :hasData= isFound
    :queryData= chkIAAData
    :custInfo= customerForIAA
    @submit="iaaCheckSubmit"
    @close="panelClose('iaaCheckOpen')"/>

    <!-- <memo-modal
    :open="memoModalOpen"
    :inputs="memoData"
    @submit="memoSubmit"
    @close="panelClose('memoModalOpen')"
    /> -->

    <warning-modal
    :open="WarningModalOpen"
    :message="warningMessage"
    confirmText="我已了解"
    @submit="panelClose('WarningModalOpen')"
    :showCancel="false"
    />

    <!-- 客戶標籤說明視窗 -->
    <tag-info-modal
      :open="tagInfoModalOpen"
      :data="custTag"
      :def="custTagDef"
      @close="panelClose('tagInfoModalOpen')"
    />

    <!-- 客戶標籤視窗 -->
    <cust-tag-modal
      :open="custTagModalOpen"
      :data="selectTag"
      @close="panelClose('custTagModalOpen')"
      @selectCust="reGetCust"
    />

    <!-- 提醒事項視窗 -->
    <attention-modal
      :open="attentionModalOpen"
      :attention="selectAttention"
      :attentionName="selectAttentionName"
      :attentionID="selectAttentionID"
      @close="panelClose('attentionModalOpen')"
    />

    <!-- 確認加入群組類型視窗 -->
    <confirm-group-modal
      :open="confirmGroupModalOpen"
      @close="panelClose('confirmGroupModalOpen')"
      @addToCurrentGroup="addToCurrentGroup"
      @createNewGroup="createNewGroup"
    />

    <!-- 加入現有群組視窗 -->
    <add-to-group-new-modal
       type="CustomerDetail1Use"
      :open="addToGroupNewModalOpen"
      :custName="CustInfo.name"
      :allGroup="grpsOfAgnt"
      :selectedGroup="grpsOfCust"
      @submit="addToGrpSubmit"
      @close="panelClose('addToGroupNewModalOpen')"
    />

    <!-- 成立新的群組視窗 -->
    <group-new-modal
       type="CustomerDetail1Use"
       source="CustomerDetail1"
      :open="groupNewModalOpen"
      :custName="CustInfo.name"
      :allGroup="grpsOfAgnt"
      :selectedGroup="grpsOfCust"
      @submit="groupSubmit"
      @close="panelClose('groupNewModalOpen')"
    />
    <!--網路服務推薦連結-->
    <recommand-app-Modal
    :open="RecommandAppOpen"
    :mmlUrl="mmlUrl"
    :fbMetaUrl="fbMetaUrl"
    :bankText="bankText"
    :bankUrl="bankUrl"
    :credentialsText="credentialsText"
    :credentialsUrl="credentialsUrl"
    @close="panelClose('RecommandAppOpen')"/>

    <!--高齡投保評估量表-->
    <eld-evaluation-form-modal
      :open="EldEvaluationFormOpen"
      :id="this.$store.state.custInfo.ID"
      :name="this.$store.state.custInfo.name"
      :birthday="this.$store.state.custInfo.birthday"
      @close="panelClose('EldEvaluationFormOpen')"
    />

    <!--高齡關懷包連結-->
    <eld-solicitude-form-modal
      :open="EldSolicitudeFormOpen"
      :data="eldSolicitudeForm.data"
      @insertLog="doInsertLog"
      @close="panelClose('EldSolicitudeFormOpen')"
    />

    <!--親疏等級-->
    <cont-score-modal
      :open="contScoreModalOpen"
      :custId="this.$store.state.custInfo.ID"
      @close="panelClose('contScoreModalOpen')"
      @openSurveyModal="openSurveyModal()"
    />

    <!-- 泰好客說明視窗 -->
    <cathay-cust-info-modal
      :open="cathayCustInfoModalOpen"
      @close="panelClose('cathayCustInfoModalOpen')"
    />

    <!-- 投資風險屬性說明視窗 -->
    <risk-attributes-modal
      :open="riskAttributesModalOpen"
      :kyc_lvl_name="lvl_chi"
      :enableKYCPrint="enableKYCPrint"
      :custId="$store.state.custInfo.ID"
      :custBirth="$store.state.custInfo.birthday"
      @close="panelClose('riskAttributesModalOpen')"
    />

    <!-- 問卷視窗 -->
    <survey-modal
      :open="surveyModalOpen"
      :csid="selectedCustID"
      :ser_no="surveySerNo"
      @refresh="panelClose('surveyModalOpen')"
      @close="panelClose('surveyModalOpen')"
    />
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { commonMixin } from '../../mixins/common';
import { getCustInfo , getCustInfo_ServiceCheck, getCustInfo_Category, getReject_CathayMarketing, getAttention, addCustInfoLog, getCustInfo_MemberNetwork, getRisk_Attributes } from '../../service';
import { getGroupOfCust } from '../../service';
import { getGroupMember } from '../../service';
import { getGroupOfAgnt } from '../../service';
import { updateGroupsByCust } from '../../service';
import { queryIAA } from '../../service';
import { queryIAACust } from '../../service';
import { editCustFinancial } from '../../service';
import { editCustInfo } from '../../service';
import { getCustIAA } from '../../service';
import { queryHousingLoans } from '../../service';
import { getCustDie } from '../../service';
import { checkNotice } from '../../service';
import { contactLetter } from '../../service';
import { queryDeleteConsumer } from '../../service';
import { addCustTagLog } from '../../service';
import { getEldSolicitudeUrl } from '../../service';
import { insertEldSolicitudeLog } from '../../service';
import { insertMemo, modifyMemo } from "@/service";
import { insertDataCollectionLog } from "@/service";

import IndexIntegratedAddressModal from "../components/IndexIntegratedAddressModal";
import CustomerInfo from '../components/CustomerDetail/CustomerInfo';
import TabHeader from '../components/CustomerDetail/TabHeader';
import GroupMemberModal from '../components/GroupMemberModal';
import SocialDataModal from '../components/SocialDataModal';
import BasicInfoModal from '../components/BasicInfoModal.vue';
import NoChangeNotice from '../components/NoChangeNotice';
import ChangeNoticeType from '../components/ChangeNoticeType';
import ContactLetter from '../components/ContactLetter';
import FinancialModal from '../components/FinancialModal';
import IaaReportModal from '../components/IaaReportModal';
import IaaCheckModal from '../components/IaaCheckModal';
import AddToGroupModal from '../components/AddToGroupModal';
import ServiceModal from '../components/ServiceModal';
import RecommandAppModal from '../components/RecommandAppModal';
import EldEvaluationFormModal  from '../components/EldEvaluationFormModal';
import EldSolicitudeFormModal  from '../components/EldSolicitudeFormModal';
import VipModal from '../components/VipModal';
import SendModal from "../components/ListsArea/SendModal";
import MemoModal from '@/desktop/components/MemoModal';
import RejectMarketingModal from '../components/RejectMarketingModal';
import WarningModal from '../components/WarningModal'
import { setTimeout } from 'timers';
import { log } from 'util';
import TagInfoModal from '../components/TagInfoModal';
import CustTagModal from '../components/CustTagModal';
import AttentionModal from '../components/AttentionModal';
import ConfirmGroupModal from '../components/ConfirmGroupModal';
import AddToGroupNewModal from '../components/AddToGroupNewModal';
import GroupNewModal from '../components/GroupNewModal';
import CathayCustInfoModal from '../components/CathayCustInfoModal';
import RiskAttributesModal from '../components/RiskAttributesModal';
import SurveyModal from "@/desktop/components/SurveyModal";
import ContScoreModal from "@/desktop/components/ContScoreModal";


import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { getJSON } from 'jquery';

const custInfo = {
    lv: 3,
    gender: 0,
    familyLeader: true,
    birthday: '',
    name: '',
    mobile: '',
    phone: '',
    
    ID: '',
    office_phone: '',
    address: ['', '', '', ''],
    office_address: ['', '', '', ''],
    lineid: '',
  }
const custData = {
    remark: '',
    fax: '',
    career: '',
    agency: '',
    marriage: '',
    relate: '',
    introducer: '',
    introducerId: '',
    email: '',
    education: ''
  }
const custIaa = {
    mobile1: '',
    mobile2: '',
    phone: '',
    address: '',
    email: ''
  }
const custFinancial = {
    household_income: '',
    personal_income: '',
    monthly_invest: '',
    finance_tool: '',
    houseloan: '',
    housing: '',
    vehicle: ''
  }
const custDecline = []
const custFamily = [
    {
      link: 1,
      name: '',
      gender: 0,
      identity: '',
      role: '',
      birthday: ''
    },
  ]
const custRecord = [
    {
      year: 94,
      data: []
    },
  ]
const custNote = ""

export default {
  name: 'CustomerDetail1',
  mixins: [commonMixin],
  data () {
    return {
      WarningModalOpen:false,
      loading_1: true,
      loading_2: true,
      loading_3: true,
      loading_4: true,
      loading_5: true,
      selectedService: 0,
      custDie:false,
      selectedServiceInstance: null,
      currentTab: 0,
      custPersonalInfo: custData,
      custIaa: {},
      custFinancial: custFinancial,
      custDecline: custDecline,
      isFound: null,
      chkIAAData: [],
      isReported: false, 
      addressData: {},
      sendCustData: {},
      //給公版列印用
      contactLetterData: {
        agidno: "",
        agnt_name: "",
        cedvno: "",
        csidno: "",
        cs_name: "",
        iaa_addr: "",
        iaa_zip: ""
      },
      IndexIntegratedAddressModalOpen: false,
      isnocontractrelation:'',
      visit_no:'',
      ceapcnm:'',
      fin:'',
      sendType: 'send',
      rejectCathay:false,
      // customer: {
      //   info: store.getters.CustInfo,
      //   data: custData,
      //   iaa: custIaa,
      //   financial: custFinancial,
      //   decline: custDecline,
      //   family: custFamily,
      //   record: custRecord,
      //   note: custNote
      // },
      saleNotificationCollapse: false,
      categoryCollapse: false,
      groupCollapse: false,
      selectedInsureType: 1,
      vipModalOpen: false,
      addToGroupOpen: false,
      serviceModalOpen: false,
      groupModalOpen: false,
      socialDataOpen: false,
      basicInfoOpen: false,
      NoChangeNoticeOpen:false,
      ChangeNoticeTypeOpen:false,
      ContactLetterOpen: false,
      sendModalOpen: false,
      financialOpen: false,
      RecommandAppOpen: false,
      EldEvaluationFormOpen: false,
      EldSolicitudeFormOpen: false,
      contScoreModalOpen: false,
      iaaReportOpen: false,
      iaaCheckOpen: false,
      memoModalOpen: false,
      RejectMarketingModalOpen: false,
      memoData: {
        memo: '',
        memohtml: '',
        upd_time: '',
        upd_id: '',
        upd_source: '',
        isNew: false,
        custType:'' //客戶類型 (Y:有ID / N:無ID)
      },
      selectedGroup: {
        grp_name: '',
        grp_id: ''
      },
      selectedNo: '',
      serviceCHANGEONLINE: {
        id: 'serviceCHANGEONLINE',
        name: '會員/網路服務資格',
        status: 0,
        link: 0,
        positiveMsg: '已完成',
        normalMsg: '部分項目未完成',
        negativeMsg: '未辦理',
        changeonline:[]
      },
      serviceFITBACK: {
        id: 'serviceFITBACK',
        name: 'Fitback健康吧',
        status: 1,
        link: 1,
        positiveMsg: '',
        fitback:[]
      },
      serviceESERVER: {
        id: 'serviceESERVER',
        name: '行動服務',
        status: 0,
        link: 0,
        positiveMsg: '已辦理',
        normalMsg: '申請同時變更(紙本未繳回)',
        negativeMsg: '尚未申辦'
      },
      servicePAYMENT_APPLY: {
        id: 'servicePAYMENT_APPLY',
        name: 'ID一指通',
        status: 0,
        link: 0,
        positiveMsg: '已辦理',
        negativeMsg: '尚未申辦',
        payment_apply: []
      },
      serviceCSEMAIL: {
        id: 'serviceCSEMAIL',
        name: '電子單據',
        status: 0,
        link: 0,
        positiveMsg: '已辦理',
        negativeMsg: '尚未申辦',
        csemail: ''
      },
      servicePLCNOS: {
        id: 'servicePLCNOS',
        name: '轉帳申請',
        status: 0,
        link: 0,
        positiveMsg: '',
        negativeMsg: '尚無需求',
        plcnos: []
      },
      serviceSHOW_ECALL: {
        id: 'serviceSHOW_ECALL',
        name: '易Call保',
        status: 0,
        link: 0,
        positiveMsg: '已辦理',
        negativeMsg: '未辦理',
        ecall: []
      },
      servicePL_LOAN: {
        id: 'servicePL_LOAN',
        name: '保單貸款',
        status: 0,
        link: 0,
        positiveMsg: '已辦理',
        negativeMsg: '尚未符合貸款資格',
        pl_loan: []
      },
      serviceCLAIM_OFFSET_BILL: {
        id: 'serviceCLAIM_OFFSET_BILL',
        name: '理賠抵繳',
        status: 0,
        link: 0,
        positiveMsg: '已辦理',
        negativeMsg: '尚未申辦'
      },
      serviceFACE_STATUS: {
        id: 'serviceFACE_STATUS',
        name: '人臉辨識服務',
        link: 1,
        positiveMsg: '暫時無法取得資料',
        status: {}
      },
      customerForIAA: {},
      serviceItems: [],
      saleNotification: ['未買投資型客戶', '差額升等VIP', '滿期金帳戶', '年金客戶', '車險預約投保', '保單貸款', '滿期金帳戶', '年金客戶', '車險預約投保', '保單貸款'],
      grpsOfCust: [],
      grpMemList: [],
      grpsOfAgnt: [],
      currentDelIndex: 0,
      custCategory: [],
      custType:'', //客戶類型 (Y:有ID / N:無ID)
      fromBox: false, //不透過客戶連結，直接由 App 存取
      custTag:[], //客戶標籤
      custTagDef:{}, //客戶標籤定義
      tagCollapse: false,
      tagInfoModalOpen: false,
      custTagModalOpen: false,
      selectTag:{}, //點選的客戶標籤
      boxLinkNegativeServices: ['serviceESERVER', 'servicePAYMENT_APPLY', 'servicePLCNOS', 'serviceSHOW_ECALL', 'serviceCLAIM_OFFSET_BILL'], //在 Box 內執行，尚未申辦、尚無需求，顯示連結的申辦項目
      attention:[], //注意事項
      attentionCollapse: false,
      attentionModalOpen: false,
      selectAttention:[], //點選的注意事項
      selectAttentionID:'', //點選的注意事項ID
      selectAttentionName:'', //點選的注意事項名稱
      injuryInsurance : {
        id: 'injuryInsurance',
        name: '傷害險續保增額提醒',
        modalTitle: '通知函明細',
        data: []
      },
      spilloverPolicy : {
        id: 'spilloverPolicy',
        name: '外溢保單資訊查詢',
        modalTitle: '外溢保單資訊查詢',
        data: []
      },
      CathayAppRecommend : {
        id: 'CathayAppRecommend',
        name: '網路服務推薦連結'
      },
      eldEvaluationForm: {
        id: 'EldEvaluationForm',
        name: '高齡投保評估量表',
        modalTitle: '高齡投保評估量表',
        data: []
      },
      eldSolicitudeForm: {
        id: 'EldSolicitudeForm',
        name: '照護資訊連結',
        modalTitle: '照護資訊連結',
        data: []
      },
      contScore : {
        id: 'ContScore',
      },
      confirmGroupModalOpen: false,
      addToGroupNewModalOpen: false,
      groupNewModalOpen: false,
      mmlUrl:'',
      fbMetaUrl:'',
      credentialsUrl:'',
      credentialsText:'',
      bankUrl:'',
      bankText:'',
      cwpUrl:'',
      cwpText:'',
      agntNewCathayNo: "",
      runEnv: false, //CustomerInfo 不執行初始化查詢
      cathayCustInfo: {}, //泰好客資料
      cathayCustInfoModalOpen: false,
      riskAttributesModalOpen: false,
      lvl_chi: '', //KYC代碼中文類型
      kyc_lvl: '', //KYC代碼
      eft: '', 
      eft_date: '',
      confirmed_status: '', //是否已追認
      is_empty: '', //是否為有ID無生日
      riskAttributesText: '',
      enableKYCPrint: true, //聲明書列印按鈕是否啟用
      custSource1: '0', //壽險來源
      CathaySurvey : {
        id: 'CathaySurvey',
        name: '未拜訪回饋'
      },
      surveyModalOpen: false, //問卷視窗開啟
      selectedCustID: "", //點選的客戶ID
      surveySerNo: "", //問卷類別
      is_open_mkt_type: "N" //是否開啟行銷分
    }
  },
  metaInfo() {
    return {
      meta: [
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: this.fbMetaUrl },
        {
          property: 'og:description',
          content: "開通國泰人壽網路服務，輕鬆管理保險大小事，點網址開通得小樹點再享其它大獎中獎機會！(若推薦人未帶出，可以輸入AG"+this.agntNewCathayNo+"為他打氣喔)"
        }
      ]
    }
  },
  components: { 
    WarningModal,
    CustomerInfo, TabHeader, // basic component
    IndexIntegratedAddressModal,
    GroupMemberModal,
    SocialDataModal,
    BasicInfoModal,
    FinancialModal,
    IaaReportModal,
    IaaCheckModal,
    AddToGroupModal,
    ServiceModal,
    RecommandAppModal,
    EldEvaluationFormModal,
    EldSolicitudeFormModal,
    VipModal,
    MemoModal,
    NoChangeNotice,
    ChangeNoticeType,
    ContactLetter,
    SendModal,
    RejectMarketingModal,
    TagInfoModal,
    CustTagModal,
    AttentionModal,
    ConfirmGroupModal,
    AddToGroupNewModal,
    GroupNewModal,
    CathayCustInfoModal,
    RiskAttributesModal,
    SurveyModal,
    ContScoreModal
  },
  computed: {
    ...mapGetters(['BaseUrl', 'CustInfo', 'UserInfo', 'GetCategoryStatus']),
    IAACheck(){
      let hasVal = false
      for(let index in this.custIaa){
        if(this.custIaa[index] !== ''){
          hasVal = true
        }
      }
      return hasVal
    },
    warningMessage(){ 
      return '客戶「<span class="text-green">'+ this.$store.state.custInfo.name +'</span>」已列入「即將刪除客戶」名單中，若需展延保留<div>，請針對以下欄位（包含：<span class="text-red">家戶歸戶、個人資訊、保單資訊、備註、排訪 </span>)</div><div><span class="text-red">擇一完成資料編輯或更新。</span></div>'
    },
    isBox() {
      // 判斷是否為 box
      return (this.UserInfo.userType === 'box') || this.fromBox;
    },
    messageWithBr(){
      return this.riskAttributesText.replace(/\n/,'<br>')
    }
  },
  watch: {
    "$route": 'initCustomerDetail1',
    CustInfo: function(newValue, oldValue) {
      if(oldValue.ID == '' && newValue.ID != '' && oldValue.serNo != '' && newValue.serNo != '') {
        let custInfo = newValue
        custInfo['serNo'] = ''
        this.updateCustInfo(custInfo)
        this.initCustomerDetail1();
      }
    }
  },
  methods: {
    ...mapActions([
      'setPageLock', 'updateCustInfo' , 'updateCustID', 'updateSerNo', 'setListAreaSerNo'
    ]),
    openBusinessModal (btn) {
      if (btn === '差額升等VIP') {
        this.panelOpen('vipModalOpen')
      }
    },
    // financialSubmit(form) {
    //   this.panelClose('financialOpen')
    //   let updateData = Object.assign({}, form)
    //   let defaultFinanceTool = ['0','0','0','0','0','0','0','0','0']
    //   form.finance_tool.map(item => defaultFinanceTool[Number(item) -1] = item)
    //   updateData.finance_tool = defaultFinanceTool.join('')
    //   let id = '';
    //   if(this.custType === 'Y'){
    //     id = this.$store.state.custInfo.ID;
    //   } else {
    //     id = this.$store.state.custInfo.serNo;
    //   }
    //   editCustFinancial(this.$store.state.userInfo.id, id, updateData, this.custType).then(result => {
    //     if(result.header && result.header.status == '200') {
    //       this.$toast.info({title: result.header.message})
    //       this.initCustomerDetail1()
    //     } else {
    //       this.$toast.info({title: result.header.message})
    //     }
    //   })  
    // },
    dataSubmit(form) {
      this.panelClose('basicInfoOpen')
      //紀錄log
      let id = this.custType === 'Y' ? this.$store.state.custInfo.ID : this.$store.state.custInfo.serNo
      insertDataCollectionLog(this.$store.state.userInfo.id, id, "EDIT_BASICINFO").then(result => {
        if (!result.header || !result.header.status === '200') {
          if (result.header.message) {
            this.$toast.info({ title: result.header.message })
          } else {
            this.$toast.info({ title: `${resMessage}` })
          }
        }
      })

      // 紀錄發查api錯誤次數
      let apiErrorCount = 0
      // 更新財務資料
      let updateData = Object.assign({}, form)
      let defaultFinanceTool = ['0', '0', '0', '0', '0', '0', '0', '0', '0']
      form.finance_tool.map(item => defaultFinanceTool[Number(item) - 1] = item)
      updateData.finance_tool = defaultFinanceTool.join('')

      const promises = [
        editCustFinancial(this.$store.state.userInfo.id, id, updateData, this.custType).then(result => {
          if (!result.header || !result.header.status == '200') {
            this.$toast.info({ title: result.header.message })
            apiErrorCount++
          }
        }),

        // 更新基本資料
        editCustInfo(this.$store.state.userInfo.id, this.$store.state.custInfo.ID, null, form).then(result => {
          if (result.header.status && result.header.status == '200') {
            if (this.isBox) {
              const custInfo = this.$store.state.custInfo;
              let custId = custInfo.ID !== '' ? custInfo.ID : custInfo.serNo
              //若内嵌於Box, 將客戶資訊回傳給Box
              this.boxCustInfoUpdate(custId, custInfo.name);
            }
          } else {
            this.$toast.info({ title: `${result.header.message}` })
            apiErrorCount++
          }
        }),

        // 更新備註
        (this.memoData.isNew
          ? insertMemo(this.$store.state.userInfo.id, id, form.memoText, this.memoData.custType)
          : modifyMemo(this.$store.state.userInfo.id, id, form.memoText, this.memoData.custType)
        ).then(result => {
          if (!result.header || result.header.status !== '200') {
            this.$toast.info({ title: `${result.header.message}` });
            apiErrorCount++;
          }
        })

      ]

      Promise.all([...promises]).then(() => {
        if (apiErrorCount === 0) {
          this.$toast.info({ title: '更新成功' })
        }
        this.initCustomerDetail1()
      })
    },
    selectGroup(item) {
      this.getGroupMamberByGrpId(this.$store.state.userInfo.id, item.grp_id, item)
    },
    //重新取得客戶資訊(透過客戶群組頁面)
    reGetCustDetail(params) {
      if (this.isBox) {
        //若内嵌於Box, 將客戶資訊回傳給Box
        this.boxCustInfo(params.csid, params.csname);
      } else {
        this.panelClose('groupModalOpen')
        this.updateCustID(params.csid)
        localStorage.groupID = params.csid
        this.$router.push({ name: 'transpage', params:{url: `/detail/groupID/tab/1`} });
      }
    },
    submitIAAReport () {
      this.panelClose('iaaReportOpen')
      queryIAACust(this.$store.state.userInfo.id, this.$store.state.custInfo.ID, 'queryAPI').then(result =>{
        if(result.body) {
          this.customerForIAA = result.body.detail || {}
        } 
      })
      this.panelOpen('iaaCheckOpen')
    },
    openAddressModal() { //打開整合地址
      this.panelOpen("IndexIntegratedAddressModalOpen");
    },
    iaaCheckSubmit (isSuccess) {
      this.isReported = isSuccess
      this.panelClose('iaaCheckOpen')
      this.$toast.info({'title':'感謝您的回報，後續將由相關單位與客戶確認，並依實際聯繫情形更新資訊！！'})
    },
    async checkNotice(){
        //查詢是否有異動後實質接觸名細
       await checkNotice(this.$store.state.userInfo.id,this.$store.state.custInfo.ID).then(result => {
        if(result && result.header.status == '200' && result.body){
          let data = result.body.notice_list
          if(data[0]){
            this.visit_no = data[0].visit_no
            this.fin = data[0].fin
            this.ceapcnm = data[0].ceapcnm
            this.sendCustData = {  
                ceapcno : this.$store.state.custInfo.ID || '',
                visit_no : this.visit_no || '',
                ceapcnm : this.ceapcnm || ''     
            }
            this.panelOpen('ChangeNoticeTypeOpen')
          }else{
            //查詢是否有經手收費關係
            contactLetter("8", this.$store.state.userInfo.id, this.$store.state.custInfo.ID, null).then(result => {
              if(result && result.header.status == '200' && result.body){
                let data = result.body.contact_letter;
                if(data[0].source1_pltn === '1' || data[0].source1_pltn === '2' || data[0].source1_pltn === '3'){
                  this.contactLetterData.agidno = this.$store.state.userInfo.id || '';
                  this.contactLetterData.agnt_name = this.$store.state.userInfo.name || '';
                  this.contactLetterData.cedvno = this.$store.state.userInfo.divNo || '';
                  this.contactLetterData.csidno = this.$store.state.custInfo.ID || '';
                  this.contactLetterData.cs_name = this.$store.state.custInfo.name || '';
                  this.panelOpen('ContactLetterOpen')
                } else {
                  this.panelOpen('NoChangeNoticeOpen');
                }
              }
            })
          }
        }
      });
    },
    selectType(type){
      //0表示尚未完成，依照異動後實質接觸明細傳送
      if(this.fin === '0'){
        this.sendType = type
      }else{
        if(type === '1'){
          this.sendType = '6'
        }else{
          this.sendType = '7'
        }
      }       
      this.panelClose('ChangeNoticeTypeOpen')
      this.panelOpen('sendModalOpen')
    },
    iaaReportColse (isSuccess) {
      if(isSuccess) {
        this.isReported = isSuccess
        this.$toast.info({'title':'感謝您的回報，後續將由相關單位與客戶確認，並依實際聯繫情形更新資訊！！'})
      }
      this.panelClose('iaaReportOpen')
    },
    iaaCheckColse (isSuccess) {
      if(isSuccess) {
        this.isReported = isSuccess
        this.$toast.info({'title':'感謝您的回報，後續將由相關單位與客戶確認，並依實際聯繫情形更新資訊！！'})
      }
      this.panelClose('iaaCheckOpen')
    },
    setCustInfo(user) {
      let custInfo = {
        lv: Number(user.vip_lvl || '0'),
        familyLeader: false,
        name: user.name || '',
        gender: user.sex || 0,
        birthday: user.birthday || '',
        ID: user.id || '',
        age: (user.age==0 ||user.age) ? user.age :'',
        serNo: user.ser_no || '',
        lineid: user.lineid || '',
        mobile: user.mobile? user.mobile.trim() : '',
        phone: [user.home_tel_area? user.home_tel_area.trim() : '', user.home_tel? user.home_tel.trim() : ''],
        office_phone: [user.corp_tel_area? user.corp_tel_area.trim() : '', user.corp_tel? user.corp_tel.trim() : '', user.corp_tel_ext? user.corp_tel_ext.trim() : ''],
        fax: [user.fax_area? user.fax_area.trim() : "", user.fax? user.fax.trim() : ""],
        // fax: '',
        address: [user.home_addr_zip? user.home_addr_zip.trim() : '', user.home_addr1? user.home_addr1.trim() : '', user.home_addr2? user.home_addr2.trim() : '', user.home_addr3? user.home_addr3.trim() : ''],
        office_address: [user.corp_addr_zip? user.corp_addr_zip.trim() :'', user.corp_addr1? user.corp_addr1.trim() :'', user.corp_addr2? user.corp_addr2.trim() :'', user.corp_addr3? user.corp_addr3.trim() :''],
        wg_name: user.wg_name || '',
        relation: user.relation || '',
        is_lia: user.is_lia || ''
      }
      this.updateCustInfo(custInfo)
      this.loading_1 = false
    },
    setCustPersonalInfo(user) {
      let idmark = ''

      if(user.idmark){
        let mark1 = user.idmark.source1 && user.idmark.source1 == '1'? '要': ''
        let mark2 = user.idmark.source2 && user.idmark.source2 == '1'? '被': ''
        let mark3 = user.idmark.source3 && user.idmark.source3 == '1'? '意': ''
        let mark4 = user.idmark.source4 && user.idmark.source4 == '1'? '產': ''
        let mark5 = user.idmark.source5 && user.idmark.source5 == '1'? '團': ''
        let mark6 = user.idmark.source6 && user.idmark.source6 == '1'? '借': ''
        idmark = mark1 + mark2 + mark3 + mark4 + mark5 + mark6
        //idmark = mark1 + mark2 + mark3 + mark5 + mark6
      }

      let relate1_pltn = user.relation ? user.relation.source1_pltn : '0'
      switch (relate1_pltn) {
        case '0':
          relate1_pltn = ''
          break
        case '1':
          relate1_pltn = '經手件'
          break
        case '2':
          relate1_pltn = '服務件'
          break
        case '3':
          relate1_pltn = '經手服務件'
          break
        default:
          relate1_pltn = ''
          break
      }

      let relation = ''
      if(user.relation){
        let relate1 = user.relation.source1 && user.relation.source1 == '1'? '壽': ''
        let relate2 = user.relation.source2 && user.relation.source2 == '1'? '產': ''
        let relate3 = user.relation.source3 && user.relation.source3 == '1'? '意': ''
        let relate4 = user.relation.source4 && user.relation.source4 == '1'? '借': ''
        let relate5 = user.relation.source5 && user.relation.source5 == '1'? '團': ''
        let relate6 = user.relation.source6 && user.relation.source6 == '1'? '他': ''
        relation = relate1 + relate2 + relate3 + relate4 + relate5 + relate6
        //relation = relate1 + relate3 + relate4 + relate5 + relate6
      }

      // 轉換婚姻格式
      let transformMarry = ""
      switch (user.marry) {
        case "1" :
          transformMarry = "未婚";
          break;
        case "2" :
          transformMarry = "已婚";
          break;
        case "3" :
          transformMarry = "離婚";
          break;
        case "4" :
          transformMarry = "其他";
      }

      // 轉換住屋狀況格式
      let transformHousingStatus = ""
      switch (user.housing_status) {
        case "1" :
          transformHousingStatus = "獨居";
          break;
        case "2" :
          transformHousingStatus = "與家人同住";
          break;
        case "3" :
          transformHousingStatus = "與65歲以上親屬同住";
          break;
        case "4" :
          transformHousingStatus = "與照顧者或看護同住";
          break;
        case "5" :
          transformHousingStatus = "居住於照護機構";
      }

      // 轉換學歷格式
      let transformEdu = ""
      switch (user.edu) {
        case "1" :
          transformEdu = "國中及以下";
          break;
        case "2" :
          transformEdu = "高中/職";
          break;
        case "3" :
          transformEdu = "專科";
          break;
        case "4" :
          transformEdu = "大學";
          break;
        case "5" :
          transformEdu = "研究所以上";
      }

      // 轉換職業格式
      let transformJob = ""
      switch (user.job) {
        case "01" :
          transformJob = "農業";
          break;
        case "02" :
          transformJob = "林業";
          break;
        case "03" :
          transformJob = "漁業";
          break;
        case "04" :
          transformJob = "畜牧業";
          break;
        case "05" :
          transformJob = "建築營造業";
          break;
        case "06" :
          transformJob = "製造業";
          break;
        case "07" :
          transformJob = "貿易業";
          break;
        case "08" :
          transformJob = "運輸倉儲業";
          break;
        case "09" :
          transformJob = "金融保險業";
          break;
        case "10" :
          transformJob = "娛樂運動業";
          break;
        case "11" :
          transformJob = "服務業";
          break;
        case "12" :
          transformJob = "餐旅美容業";
          break;
        case "13" :
          transformJob = "公務員";
          break;
        case "14" :
          transformJob = "教育業";
          break;
        case "15" :
          transformJob = "軍警業";
          break;
        case "16" :
          transformJob = "自由業";
          break;
        case "17" :
          transformJob = "家管";
          break;
        case "18" :
          transformJob = "學生";
          break;
        case "19" :
          transformJob = "無業";
          break;
        case "20" :
          transformJob = "中小學以上教師";
          break;
        case "21" :
          transformJob = "律師、醫師、會計師、建築師、引水人";
          break;
        case "22" :
          transformJob = "電子業";
          break;
        case "23" :
          transformJob = "資訊業";
          break;
        case "24" :
          transformJob = "其他";
      }
      
      this.custPersonalInfo = {
        remark: idmark.length > 0? idmark : '— —',
        fax: [user.fax_area? user.fax_area.trim() : '', user.fax? user.fax.trim() : ''],
        career: transformJob,
        career_box:user.std_occupation_cd || '',
        job_name:user.job_name || '',
        job_cat:user.job_cat || '',
        agency: user.corp || '',
        marriage: transformMarry,
        housing_status: transformHousingStatus,
        housing_status_code: String(user.housing_status || ''),
        relatepltn : relate1_pltn,
        relate: relation.length > 0? relation: '— —',
        introducer: user.introducer_name || '',
        introducerId: user.introducer || '',
        email: user.email || '',
        education: transformEdu
      }
    },
    isEmptyObj(obj){
      for(let key in obj){
        return false
      }
      return true
    },
    setMemo (memo_data) {  //  設定備註
      if(memo_data) {  // 判斷備註存不存在
        if(typeof memo_data.memo !== 'undefined') {
          this.memoData.memo = memo_data.memo
          this.memoData.memohtml = memo_data.memo.replace(/\n/gm,"<br/>");
          this.memoData.upd_time = memo_data.upd_time
          this.memoData.upd_id = memo_data.upd_id
          this.memoData.upd_source = memo_data.upd_source
          this.memoData.isNew = false
        } else {
          this.memoData.memo = ''
          this.memoData.memohtml = ''
          this.memoData.upd_time = ''
          this.memoData.upd_id = ''
          this.memoData.upd_source = ''
          this.memoData.isNew = true
        }
        this.memoData.custType = memo_data.custtype;//客戶類型 (Y:有ID / N:無ID)
      }
    },
    // memoSubmit () {  // 新增修改 memo
    //   this.initCustomerDetail1()
    //   this.panelClose('memoModalOpen')
    // },
    setCustIaa(iaa) {
      if (iaa.detail) {
        let iaaData = iaa.detail || {};
        //整理顯示內容
        iaaData.mobile = iaaData.mobl_no || ""; //手機號碼
        iaaData.mobile_update = "";
        iaaData.homeTel = (iaaData.htel_area ? iaaData.htel_area + "-" : "") + (iaaData.htel_num ? iaaData.htel_num : "") + (iaaData.htel_ext ? "#" + iaaData.htel_ext : ""); //住家電話號碼
        iaaData.tel_h_update = "";
        iaaData.corpTel = (iaaData.ctel_area ? iaaData.ctel_area + "-" : "") + (iaaData.ctel_num ? iaaData.ctel_num : "") + (iaaData.ctel_ext ? "#" + iaaData.ctel_ext : ""); //公司電話號碼
        iaaData.tel_o_update = "";
        iaaData.addressData = "";
        iaaData.tel_p_update = "";
        iaaData.feeAdd = [iaaData.addr_p_postal_cd ? iaaData.addr_p_postal_cd.trim() : "" , iaaData.addr_p_city_nm ? iaaData.addr_p_city_nm.trim() : "", iaaData.addr_p_line_1 ? iaaData.addr_p_line_1.trim() : "", iaaData.addr_p_line_2 ? iaaData.addr_p_line_2.trim() : ""]; //收費地址
        iaaData.censusAdd = [iaaData.addr_h_postal_cd ? iaaData.addr_h_postal_cd.trim() : "" , iaaData.addr_h_city_nm ? iaaData.addr_h_city_nm.trim() : "", iaaData.addr_h_line_1 ? iaaData.addr_h_line_1.trim() : "", iaaData.addr_h_line_2 ? iaaData.addr_h_line_2.trim() : ""]; //戶籍地址
        iaaData.contactAdd = [iaaData.addr_c_postal_cd ? iaaData.addr_c_postal_cd.trim() : "" , iaaData.addr_c_city_nm ? iaaData.addr_c_city_nm.trim() : "", iaaData.addr_c_line_1 ? iaaData.addr_c_line_1.trim() : "", iaaData.addr_c_line_2 ? iaaData.addr_c_line_2.trim() : ""]; //聯絡地址
        iaaData.email_update_date = "";
        this.custIaa = iaaData; //聯絡資訊(公司提供)
        this.addressData = iaaData; //看更多(客戶通聯資料)
        this.custIaa.address = this.$options.filters.addressFormat(this.custIaa.feeAdd);
        //給公版列印用
        this.contactLetterData.iaa_addr = iaaData.addr_newest_city_nm + iaaData.addr_newest_line_1 + iaaData.addr_newest_line_2;
        this.contactLetterData.iaa_zip = iaaData.addr_newest_postal_cd;
      }
    },
    setCustFinancial(finanical) {
      
      if(this.isEmptyObj(finanical)){
        return false
      }

      // 轉換家庭年收入格式
      let transformFamily_incom = ""
      switch (finanical.family_incom) {
        case "1" :
          transformFamily_incom = "60萬以下";
          break;
        case "2" :
          transformFamily_incom = "61萬~80萬";
          break;
        case "3" :
          transformFamily_incom = "81萬~100萬";
          break;
        case "4" :
          transformFamily_incom = "101萬~150萬";
          break;
        case "5" :
          transformFamily_incom = "151萬~200萬";
          break;
        case "6" :
          transformFamily_incom = "201萬~350萬";
          break;
        case "7" :
          transformFamily_incom = "351萬以上";
      }

      // 轉換個人年所得格式
      let transformIncommy = ""
      switch (finanical.incommy) {
        case "1" :
          transformIncommy = "無";
          break;
        case "2" :
          transformIncommy = "30萬以下";
          break;
        case "3" :
          transformIncommy = "31~60萬";
          break;
        case "4" :
          transformIncommy = "61~100萬";
          break;
        case "5" :
          transformIncommy = "101~200萬";
          break;
        case "6" :
          transformIncommy = "201萬以上";
      }

      // 轉換月平均投資格式
      let transformInvest = ""
      switch (finanical.invest) {
        case "1" :
          transformInvest = "無";
          break;
        case "2" :
          transformInvest = "3千以下";
          break;
        case "3" :
          transformInvest = "3千~5千";
          break;
        case "4" :
          transformInvest = "5千~1萬";
          break;
        case "5" :
          transformInvest = "1萬~2萬";
          break;
        case "6" :
          transformInvest = "2萬~5萬";
          break;
        case "7" :
          transformInvest = "5萬以上";
      }
      
      // 轉換住屋狀況格式
      let transformHouse = ""
      switch (finanical.house) {
        case "1" :
          transformHouse = "自有";
          break;
        case "2" :
          transformHouse = "租賃";
          break;
        case "3" :
          transformHouse = "其他親屬所有";
          break;
        case "4" :
          transformHouse = "其他";
      }

      // 轉換交通工具格式
      let transformCar = ""
      switch (finanical.car) {
        case "1" :
          transformCar = "無";
          break;
        case "2" :
          transformCar = "機車";
          break;
        case "3" :
          transformCar = "汽車";
          break;
        case "4" :
          transformCar = "機車與汽車";
      }

      // 轉換理財工具格式
      let tools = [
        {text:'定存', val: '1'},
        {text:'保險', val: '2'},
        {text:'共同基金', val: '3'},
        {text:'標會', val: '4'},
        {text:'債券', val: '5'},
        {text:'股票', val: '6'},
        {text:'期貨外匯', val: '7'},
        {text:'不動產', val: '8'},
        {text:'其他', val: '9'}
      ]
      let transformtools = []
      let filtertools = tools.filter(item => finanical.finance.indexOf(item.val) >= 0).map(item => transformtools.push(item.text))
      transformtools = transformtools.join()


      this.custFinancial = {
        household_income: transformFamily_incom|| '',
        personal_income: transformIncommy|| '',
        monthly_invest: transformInvest || '',  //0
        finance_tool: transformtools || '',
        houseloan: finanical.loan_amt || '',  //0
        housing: transformHouse|| '',
        vehicle: transformCar|| ''
      }
    },
    setCustDecline(refuse_mark, comstomer) {
      this.custDecline = [
        refuse_mark.sms_promote === '1' ? 1:0,
        refuse_mark.phone_promote === '1' ? 2:0,
        refuse_mark.email_promote === '1' ? 3:0,
        refuse_mark.mail_promote === '1' ? 4:0,
        refuse_mark.agnt_promote === '1' ? 5:0,
        refuse_mark.stop_personal_data === '1' ? 6 :0,
        comstomer.relation && comstomer.relation.source2 === '2'? 7:0
      ]     
    },
    setCustServiceItem(serviceCheck) {
      let changeonlineList = serviceCheck.changeonline;
      if(changeonlineList) {
        let hasOnlineData = changeonlineList[0].hasdata;
        this.serviceCHANGEONLINE.status = hasOnlineData;
        if(hasOnlineData!=='N'){
          this.serviceCHANGEONLINE.link = 1;
          this.serviceCHANGEONLINE.changeonline = changeonlineList;
        }
      }
      // Fitback健康吧
      if (serviceCheck.fitback) {
        this.serviceFITBACK.positiveMsg = serviceCheck.fitback.level_nm ? serviceCheck.fitback.level_nm : '尚未註冊';
      }
      // 人臉辨識申請狀態
      if (serviceCheck.facestatus) {
        this.serviceFACE_STATUS.positiveMsg = serviceCheck.facestatus.title
        this.serviceFACE_STATUS.status = serviceCheck.facestatus
        this.serviceFACE_STATUS.status.linkurl = 'https://w3.cathaylife.com.tw/PIWeb/web/tc/9N0/%E6%AA%94%E6%A1%88/%E4%BA%BA%E8%87%89%E5%B0%88%E5%8D%80/%E4%BA%BA%E8%87%89%E8%BE%A8%E8%AD%98_NAP%E7%94%B3%E8%AB%8B%E6%95%99%E6%A1%88.pdf'
      }
      if (serviceCheck.eserver) {
        this.serviceESERVER.status = serviceCheck.eserver;
        // 行動服務-未申辦，在 Box 內執行，顯示連結
        if (this.isBox && this.serviceESERVER.status == 'N') {
          this.serviceESERVER.link = 1;
        } else {
          this.serviceESERVER.link = 0;
        }
      }
      if(serviceCheck.payment_apply && serviceCheck.payment_apply.length > 0) {
        this.servicePAYMENT_APPLY.status = 1
        this.servicePAYMENT_APPLY.link = 1
        this.servicePAYMENT_APPLY.payment_apply = serviceCheck.payment_apply
      }
      if(null != serviceCheck.csemail && serviceCheck.csemail.indexOf('未辦理') < 0 && serviceCheck.csemail.length > 0) {
        this.serviceCSEMAIL.status = 1
        this.serviceCSEMAIL.link = 1
        this.serviceCSEMAIL.csemail = serviceCheck.csemail
      }
      if(serviceCheck.plcnos && serviceCheck.plcnos.length > 0) {
        this.servicePLCNOS.status = 1
        this.servicePLCNOS.link = 1
        this.servicePLCNOS.plcnos = serviceCheck.plcnos
        this.servicePLCNOS.positiveMsg = '尚有保單待申請'
      }
      if(serviceCheck.show_ecall && serviceCheck.show_ecall.key.indexOf("已辦理") > -1) {
        this.serviceSHOW_ECALL.status = 1
      } else if(serviceCheck.show_ecall && serviceCheck.show_ecall.key.indexOf('詳細資訊') > -1 ) {
        if(serviceCheck.show_ecall.isshow == "Y"){
           this.serviceSHOW_ECALL.link = 1
           this.serviceSHOW_ECALL.positiveMsg = serviceCheck.show_ecall.key
        }else{
          this.serviceSHOW_ECALL.link = 0
        }
        this.serviceSHOW_ECALL.status = 1  
        this.serviceSHOW_ECALL.ecall = serviceCheck.show_ecall
      }
      // 正常效力保單 & 停效保單 是否符合貸款資格分類
      // 1. has_dtabar30 == 'Y' && lapsedpolicynodetaillist.length == 0 => 可點選 && '符合貸款資格'
      // 2. has_dtabar30 == 'Y' && lapsedpolicynodetaillist.length > 0 => 可點選 && '符合貸款資格'
      // 3. has_dtabar30 == 'N' && lapsedpolicynodetaillist.length > 0 => 可點選 && '有貸款紀錄'
      // 4. has_dtabar30 == 'N' && lapsedpolicynodetaillist.length == 0 => 不可點選 && '尚未符合貸款資格'
      if(serviceCheck.pl_loan && serviceCheck.pl_loan.has_dtabar30 === 'Y') {
        this.servicePL_LOAN.status = 1
        this.servicePL_LOAN.link = 1
        //this.servicePL_LOAN.pl_loan = serviceCheck.pl_loan
        this.servicePL_LOAN.positiveMsg = '符合貸款資格'
      } else if (serviceCheck.pl_loan.has_dtabar30 === 'N' && serviceCheck.pl_loan.lapsedplloanlist.length > 0) {
        this.servicePL_LOAN.status = 1
        this.servicePL_LOAN.link = 1
        this.servicePL_LOAN.positiveMsg = '有貸款紀錄'
      }

      if(null != serviceCheck.claim_offset_bill && serviceCheck.claim_offset_bill.indexOf('尚未申辦') < 0) {
        this.serviceCLAIM_OFFSET_BILL.status = 1
      }
      this.custSource1 = serviceCheck.getsource1;//業務員和客戶的經手(服務)關係
      if (this.custSource1 && this.custSource1 == '0') {
        this.serviceCHANGEONLINE.link = 0; //會員/網路服務資格
        this.servicePAYMENT_APPLY.link = 0; //ID一指通
        this.serviceCSEMAIL.link = 0; //電子單據
      }
      if (this.custSource1 && this.custSource1 != '0') {
        this.custTag = serviceCheck.cust_tag || []; //客戶標籤
        this.custTagDef = serviceCheck.cust_tag_def || {}; //客戶標籤定義
        this.cathayCustInfo = serviceCheck.cathay_cust_info || {}; //泰好客資訊(行銷分燈號)
      } else {
        this.custTag = [];
        this.custTagDef = {};
        this.cathayCustInfo = {};
      }
      this.is_open_mkt_type = serviceCheck.is_open || "N";
    },
    setMemberNetworkItem(serviceCheck) {
      this.agntNewCathayNo = serviceCheck.new_cathay_no || ''; //業務員員工編號
      this.mmlUrl = "【國泰人壽】透過App掌握您的保單資訊，享受快速便利的服務功能，快速下載連結： https://cathay.app.link/ ，登入後點選『更多 - 點數/任務』還有多元活動等你參加。";
      this.fbMetaUrl = "https://cathay.app.link/2NuVYQEpTgb?promotion=AG&eid=" + this.agntNewCathayNo;
      this.credentialsUrl = serviceCheck.credentials_url || "https://was2.cathaylife.com.tw/ABWeb/servlet/HttpDispatcher/ABW3_0002/prompt?ID=&FROM=ABW3_0001";
      this.credentialsText = "【國泰人壽】誠摯邀請您申辦「網路服務」與「電子單據」，輕鬆管理保險大小事。快速申辦連結 "+serviceCheck.credentials_url+" ；倘申辦過程有疑問，歡迎洽詢您的服務人員，也不忘在推薦人輸入"+this.agntNewCathayNo+"為她打氣哦!" ;
      this.bankUrl = "https://cathaylife.tw/ZN4n1W";
      this.bankText = "【國泰人壽】開通網路服務，輕鬆管理保險大小事，點網址開通得小樹點再享其它大獎中獎機會！(若推薦人未帶出，可以輸入"+this.agntNewCathayNo+"為他打氣喔) 申辦請點擊 https://cathaylife.tw/ZN4n1W ；操作說明  https://cathaylife.tw/EAZA90 ；開通後請下載國泰優惠APP： https://cathaylife.tw/LvnEGd 經確認符合資格，且須開通完成，次月底即可於國泰優惠APP取得小樹點哦！";
      this.cwpUrl = serviceCheck.invite_url || "https://cathay.app.link/vTw2nKudkab";
      this.cwpText = "揪你加入「FitBack健康吧」健康計劃，點連結下載(開啟)國泰人壽APP並登入，再依步驟開通就可以囉！ " + this.cwpUrl;
    },
    checkIsOpenServiceModal(service) {
      if (this.isBox) {
        if (service.id === 'serviceESERVER' && service.status == 'N') {//行動服務－尚未申辦
          this.boxServiceItem({
            linkApp: 'CathayLifeABMI',
            linkUrl: 'NAP/ABNewContract',
            itemType: 'AL',
            itemTitle: '行動服務'
          });
        } else if (service.id === 'servicePAYMENT_APPLY' && /^[0N]$/.test(service.status)) {//ID一指通－尚未申辦
          this.boxServiceItem({
            linkApp: 'CathayLifeABMI',
            linkUrl: 'NAP/ABApplyOneFinger',
            itemType: 'AL',
            itemTitle: 'ID一指通'
          });
        } else if (service.id === 'servicePLCNOS' && /^[0N]$/.test(service.status)) {//轉帳申請－尚無需求
          this.boxServiceItem({
            linkApp: 'CathayLifeACMI',
            linkUrl: 'NAP/ACNewDebitAuth',
            itemType: 'AL',
            itemTitle: '轉帳申請'
          });
        } else if (service.id === 'serviceSHOW_ECALL' && /^[0N]$/.test(service.status)) {//易Call保－尚未辦理
          this.boxServiceItem({
            linkApp: 'CathayLifeCBMIeCall',
            linkUrl: 'NAP/Ecall/CBNewContract',
            itemType: 'AL',
            itemTitle: '易call保'
          });
        // } else if (service.id === 'servicePL_LOAN' && /^[1Y]$/.test(service.status)) {//保單貸款－已辦理
        //   this.boxServiceItem({
        //     linkApp: 'CathayLifeABMI',
        //     linkUrl: 'NAP/ABNewContract',
        //     itemType: 'AL',
        //     itemTitle: '保單貸款'
        //   });
        } else if (service.id === 'serviceCLAIM_OFFSET_BILL' && /^[0N]$/.test(service.status)) {//理賠抵繳－尚未申辦
          this.boxServiceItem({
            linkApp: 'CathayLifeAAMI',
            linkUrl: 'NAP/Life/TakeOver',
            itemType: 'AL',
            itemTitle: '理賠抵繳'
          });
        } else {
          //在APP端開啟(項目為會員/網路服務資格, 電子單據, 行動服務(狀態不為尚未申辦)。操作行為不變)
          if (service.link === 1) {
            // 如果無ID 不送API
            if (this.$store.state.custInfo.ID && !(this.$store.state.custInfo.ID).includes('~') && !this.mmlUrl) {
              //取得會員/網路服務資格 (申辦項目)
              getCustInfo_MemberNetwork(this.$store.state.userInfo.id, this.$store.state.userInfo.id, this.$store.state.custInfo.ID, "").then(result => {
                if(result.header && result.header.status === '200'){
                  this.setMemberNetworkItem(result.body.membernetworklist);
                }else{
                  if(result.header && result.header.message) {
                    this.$toast.info({title: result.header.message})
                  } else {
                    this.$toast.info({title: '查詢會員/網路服務資格失敗,請重新操作'})
                  }
                }
              });
            }
            this.selectedServiceInstance = service;
            this.panelOpen('serviceModalOpen');
          }
        }
      } else if (service.link === 1) {
        // 如果無ID 不送API
        if (this.$store.state.custInfo.ID && !(this.$store.state.custInfo.ID).includes('~') && !this.mmlUrl) {
          //取得會員/網路服務資格 (申辦項目)
          getCustInfo_MemberNetwork(this.$store.state.userInfo.id, this.$store.state.userInfo.id, this.$store.state.custInfo.ID, "").then(result => {
            if(result.header && result.header.status === '200'){
              this.setMemberNetworkItem(result.body.membernetworklist)
            }else{
              if(result.header && result.header.message) {
                this.$toast.info({title: result.header.message})
              } else {
                this.$toast.info({title: '查詢會員/網路服務資格失敗,請重新操作'})
              }
            }
          });
        }
        this.selectedServiceInstance = service;
        this.panelOpen('serviceModalOpen');
      }
    },
    getGroupMamberByGrpId(userId, grpid, item) {
      getGroupMember(userId, grpid).then(result => {
        this.grpMemList = result
        this.selectedGroup = item
        this.panelOpen('groupModalOpen')
      })
    },
    addToGrpSubmit(newSelectedGroups) {
      updateGroupsByCust(this.$store.state.userInfo.id, this.$store.state.userInfo.id, (this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo), newSelectedGroups).then(result => {
        if(result.header && result.header.status === '200') {
          this.$toast.info({title: result.header.message})
          getGroupOfCust(this.$store.state.userInfo.id, (this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo)).then(result2 => {
            if(result2.body.groups) {
              this.grpsOfCust = result2.body.groups.map(item => {
                return {
                  grp_id: item.grp_id,
                  grp_name: item.grp_name
                }
              })
              if(this.grpsOfCust && this.grpsOfCust.length > 6) {
                this.groupCollapse = true;
              }
            } else {
              this.grpsOfCust = []
            }
          })
        } else {
          this.$toast.info({title: result.header.message})
        }
      })
      this.panelClose('addToGroupNewModalOpen')
    },
    //新增群組
    groupSubmit() {
      this.$toast.info({ title: "編輯客戶所屬群組成功" });
      this.panelClose("groupNewModalOpen");
      //取得當前客戶所加入的群組資料
      getGroupOfCust(
        this.$store.state.userInfo.id,
        this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo
      ).then(result => {
        if (result.body.groups) {
          this.grpsOfCust = result.body.groups.map(item => {
            return {
              grp_id: item.grp_id,
              grp_name: item.grp_name
            };
          });
          if(this.grpsOfCust && this.grpsOfCust.length > 6) {
            this.groupCollapse = true;
          }
        } else {
          this.grpsOfCust = [];
        }
      });

      //取得當前業務員的所有群組資料
      getGroupOfAgnt(this.$store.state.userInfo.id, this.$store.state.userInfo.id,0).then(result => {
        const transformedDate = []
        if(result.body && result.body.groups){
          result.body.groups.forEach((grp) => {
            const data = {
              grp_id: grp.grp_id,
              grp_name: grp.grp_name
            }
            transformedDate.push(data)
          })
          this.grpsOfAgnt = transformedDate
        }else{
          this.grpsOfAgnt = transformedDate
        }
      })
    },
    async initCustomerDetail1() {
      // for 介紹人上一頁  讀取 query
      let loadCustId = this.$route.params.id
      if(loadCustId === 'origin'){
        //什麼事都不做
      }else if(loadCustId !== 'SerNo'){
        if (!this.fromBox) {
          this.updateCustID(decodeURI(localStorage[loadCustId]))
        }
      }else{
        this.updateSerNo(decodeURI(localStorage[loadCustId]))
      }
      if(this.$store.state.custInfo.ID && !(this.$store.state.custInfo.ID).includes('~')){
        this.custType = 'Y';
      } else {
        this.custType = 'N';
      }
      this.loading_1 = true
      this.loading_5 = true
      await getCustInfo(this.$store.state.userInfo.id, this.$store.state.userInfo.id, (this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo)).then(result => {
        if(result.header && result.header.status === '200'){
          this.setCustInfo(result.body.customer)
          this.setCustPersonalInfo(result.body.customer)
          this.setCustFinancial(result.body.financial)
          this.setCustDecline(result.body.refuse_mark, result.body.customer)
          this.setMemo(result.body.memo_data)
          this.isnocontractrelation = result.body.isnocontractrelation=="Y" ? "*" :''
          this.loading_1 = false
          this.loading_5 = false
          if (!this.UserInfo.mainUserId) {
            //客戶個人頁面點擊紀錄LOG檔
            let logData = {
              agnt_id: this.UserInfo.id,
              cust_id: this.CustInfo.ID ? this.CustInfo.ID : this.CustInfo.serNo,
              cust_name: this.CustInfo.name,
              act_type: "Q"
            };
            addCustInfoLog(this.UserInfo.id, logData);
          }
        }else{
          this.loading_1 = false
          this.loading_5 = false
          if(result.header && result.header.message) {
            this.$toast.info({title: result.header.message})
            //this.$toast.info({title: '編輯個人資訊更新成功'})
          } else {
            this.$toast.info({title: '查詢客戶資料失敗,請重新操作'})
          }
        }
        this.$refs.cust_info.init();//CustomerInfo執行初始化查詢(取得IAA資訊和收費關係)

        const IAASentChcck = ['1','2','3']
        this.loading_2 = true
        if(result.body.customer.relation && IAASentChcck.includes(result.body.customer.relation.source1_pltn)){
          getCustIAA(this.$store.state.userInfo.id, this.$store.state.custInfo.ID, 'queryAPI').then(result => {
            if(result.header && result.header.status === '200'){
              this.setCustIaa(result.body);
              this.loading_2 = false
            }else{
              this.$toast.info({title: result.header.message})
              this.loading_2 = false
            }
          })
        }else{
          this.loading_2 = false
        }
      })

      // reset selectedService
      this.selectedService = 0;
      // reset attention
      this.attention = [];

      // 如果無ID 不送API
      if (this.$store.state.custInfo.ID && !(this.$store.state.custInfo.ID).includes('~')) {
        //取得該cust詳細資訊 (申辦項目)
        this.loading_3 = true
        this.loading_4 = true
        getCustInfo_ServiceCheck(this.$store.state.userInfo.id, this.$store.state.userInfo.id, this.$store.state.custInfo.ID, this.$store.state.custInfo.birthday).then(result => {
          if(result.header && result.header.status === '200'){
            this.setCustServiceItem(result.body.service_check)
            this.loading_3 = false
          }else{
            this.loading_3 = false
            if(result.header && result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: '查詢申辦項目失敗,請重新操作'})
            }
          }
        })

        // 客戶如果無房貸資料 disable 房貸資訊頁籤
        queryHousingLoans(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result => {
          if(result && result.body && result.body.length > 0){
            this.$store.dispatch('updaHousingLoans',true)
          }else{
            this.$store.dispatch('updaHousingLoans',false)
          }
        })
        
        // 取得該 cust 死亡資訊
        getCustDie(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result => {
          if(result.header && result.header.status === '200'){
            this.custDie = true
          }else{
            this.custDie = false
          }
        })

        //取得該客戶的名單專區
        getCustInfo_Category(this.$store.state.userInfo.id, this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result => {
            if(result && result.body && result.body.categorylist.length > 0) {
                this.custCategory = result.body.categorylist.map(item => {
                    return {
                        cate_serno: item.cate_serno || '', //名單序號
                        category: item.category || '', //名單功能類別
                        category_name: item.category_name || '' //名單功能名稱
                    }
                })
            } else {
              this.custCategory = [];
            }
        })

        //取得拒絕國泰人壽行銷
        getReject_CathayMarketing(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result =>{
            if(result.header && result.header.status === "200"){
              if(result.body.id){
                 this.rejectCathay = true;
              }else{
                this.rejectCathay = false;
              }
          }
        })
        //取得投資風險屬性
        getRisk_Attributes(this.$store.state.custInfo.ID, "", this.$store.state.custInfo.birthday).then(result =>{
          if(result.header && result.header.status === "200"){
            this.lvl_chi = result.body.lvl_chi;
            this.kyc_lvl = result.body.kyc_lvl;
            this.eft = result.body.eft;
            this.eft_date = result.body.eft_date;
            this.confirmed_status = result.body.confirmed_status;
            this.is_empty = result.body.is_empty; 
            if(this.is_empty == 'Y'){
                this.riskAttributesText = '無有效風險屬性\n(請確認客戶生日資訊，詳情可點擊左方問號圖示)'
                this.eft_date = '— —'
                this.enableKYCPrint = false
            }else if(this.eft == '02'){
                this.riskAttributesText = '無有效風險屬性\n(詳情可點擊左方問號圖示)'
                this.eft_date = (this.eft_date ? this.eft_date : '— —')
                this.enableKYCPrint = false
            }else{
                if(this.kyc_lvl=='1' || this.kyc_lvl=='2' || this.kyc_lvl=='3'){
                    if(this.confirmed_status=='Y')
                      this.riskAttributesText = this.lvl_chi + ' / 客戶已確認'
                    else if(this.confirmed_status=='N')
                      this.riskAttributesText = this.lvl_chi + ' / 客戶尚未確認\n(詳情可點擊左方問號圖示)'  
                }else if(this.kyc_lvl=='0' || this.kyc_lvl==''){
                    this.riskAttributesText = '無有效風險屬性\n(詳情可點擊左方問號圖示)'
                    this.enableKYCPrint = false
                }else{
                    this.riskAttributesText = '— —'
                    this.enableKYCPrint = false
                }
            }              
          } else {
            this.riskAttributesText = '— —'
            this.enableKYCPrint = false
            if(result.header && result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: '查詢投資風險屬性失敗,請重新操作'})
            }
          }
        });

        //取得提醒事項
        this.attention.push(this.CathaySurvey);//未拜訪回饋(問卷)
        this.attention.push(this.CathayAppRecommend);//網路服務推薦連結(固定顯示)
        await getAttention(this.$store.state.userInfo.id, this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result => {
            this.loading_4 = false;
            if(result.header && result.header.status === '200') {
              this.setAttentionData(result.body.attention);
            } else {
              if(result.header && result.header.message) {
                this.$toast.info({title: result.header.message})
              } else {
                this.$toast.info({title: '查詢提醒事項失敗,請重新操作'})
              }
            }
        })
      }

      //高齡投保評估量表(固定顯示)(無ID、有ID皆顯示)
      this.attention.push(this.eldEvaluationForm);

      //高齡關懷包連結(固定顯示)(無ID、有ID皆顯示)
      getEldSolicitudeUrl(this.$store.state.userInfo.id).then((result) => {
        if (result.header && result.header.status === "0") {
          this.eldSolicitudeForm.data =
            result.body.data.filter((item) => item.memo) || []; //memo欄位有資料才顯示
          this.attention.push(this.eldSolicitudeForm);
        }
      });

      //取得當前業務員的所有群組資料
      getGroupOfAgnt(this.$store.state.userInfo.id, this.$store.state.userInfo.id,0).then(result => {
        const transformedDate = []
        if(result.body && result.body.groups){
          result.body.groups.forEach((grp) => {
            const data = {
              grp_id: grp.grp_id,
              grp_name: grp.grp_name
            }
            transformedDate.push(data)
          })
          this.grpsOfAgnt = transformedDate
        }else{
          this.grpsOfAgnt = transformedDate
        }
      })

      // 取得群組資料
      getGroupOfCust(this.$store.state.userInfo.id, (this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo)).then(result => {
        if(result.body.groups) {
          this.grpsOfCust = result.body.groups.map(item => {
            return {
              grp_id: item.grp_id,
              grp_name: item.grp_name
            }
          })
        } else {
          this.grpsOfCust = []
        }
      })
    },
    doInsertLog(option) {
      if(!this.$store.state.custInfo.ID) {
        return; //若無ID，則不寫log
      }
      insertEldSolicitudeLog(this.$store.state.userInfo.id,this.$store.state.custInfo.ID, option).then(result => {
        if(!result.header || !result.header.status === '200') {
          console.error("新增高齡關懷包Log API 錯誤");
        }
      }); 
    },
    routeToCustDetail(custId, custName) {
      if (this.isBox) {
        //若内嵌於Box, 將客戶資訊回傳給Box
        this.boxCustInfo(custId, custName);
      } else {
        let IntrAdd = "";
        if (this.$route.params.id.indexOf("intr") === -1) {
          IntrAdd = "intr1";
        } else {
          IntrAdd =
            "intr" + (this.$route.params.id.replace("intr", "") - 0 + 1);
        }
        localStorage[IntrAdd] = custId;
        this.updateCustID(custId);
        this.$router.push({ path: `/detail/${IntrAdd}/tab/1` });
      }
    },
    getFax(val){
      if(val !== 'undefined'){
          if(val[0] && val[1]){
          return val[0]+'-'+val[1];
        }else{
          return `${val[0]}${val[1]}`;
        }
      }else{
        return ''
      }
    },
    //導頁至客戶名單專區
    routeToCustCategory(serNo, category){
      if(!serNo || !category){
          return;
      }
      let linkArea = '';
      let status = this.GetCategoryStatus[serNo];
      if (category === '商品行銷') {
        linkArea = 'precision-marketing';
      } else if (category === '服務/權益') {
        linkArea = 'service-right';
      } else if (category === '整合行銷') {
        linkArea = 'integrated-marketing';
      } else if (category === '活動推廣') {
        linkArea = 'group-related';
      } else if (category === '法令專區') {
        linkArea = 'decree-zone';
      }
      this.setListAreaSerNo(serNo);
      this.$store.state.initCategoryStatus = status; //記錄點選的名單類別
      this.$router.push(`/list-area/${linkArea}?path=${status}`);
    },
    //接Box參數，查詢客戶資料
    getCustInfoFromBox(csid){
      this.fromBox = true;
      this.updateCustID(atob(csid));
      this.initCustomerDetail1();
    },
    showDeleteConsumerTip(){
      queryDeleteConsumer(this.$store.state.userInfo.id, this.$store.state.custInfo.ID , this.$store.state.custInfo.serNo)
      .then(i => {        
        if(i.header.status == 200 && !window._.isEmpty(i.body)){
          this.panelOpen('WarningModalOpen');
        } 
      });
    },
    //告知APP 頁面已加載完畢
    isReadyListenAppJS () {
      this.$nextTick(() => {
        if (window.webkit) {
          window.webkit.messageHandlers.isReadyListenAppJS.postMessage("isOK");
        }
      });
    },
    //開啟客戶標籤視窗
    openCustTagModal(data) {
      // 客戶標籤點擊留存log紀錄
      const tagLogData = {
        agnt_id: this.$store.state.userInfo.id,
        agnt_name: this.$store.state.userInfo.name,
        agnt_dvno: this.$store.state.userInfo.divNo,
        agnt_dvname: this.$store.state.userInfo.divFullName,
        cust_id: this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo,
        cust_name: this.$store.state.custInfo.name,
        tag_id: data.tag_id,
        tag_name: data.tag_name,
        cust_behavior: '1'
      };
      // 新增客戶標籤點擊留存log紀錄
      addCustTagLog(this.$store.state.userInfo.id, tagLogData);
      this.selectTag = data;
      this.panelOpen('custTagModalOpen');
    },
    //開啟標籤名稱說明視窗
    openTagInfoModal () {
      this.panelOpen('tagInfoModalOpen');
    },
    //重新取得客戶資訊(透過客戶標籤頁面)
    reGetCust(params) {
      if (this.isBox) {
        //若内嵌於Box, 將客戶資訊回傳給Box
        this.boxCustInfo(params.csid, params.csname);
      } else {
        this.panelClose('custTagModalOpen');
        this.updateCustID(params.csid);
        localStorage.partyID = params.csid;
        this.$router.push({ name: 'transpage', params:{url: `/detail/partyID/tab/1`} });
      }
    },
    //是否在 Box 顯示未申辦項目連結
    isBoxLinkNegativeService(item) {
      return this.isBox && this.boxLinkNegativeServices.includes(item.id);
    },
    //提醒事項資料初始化
    setAttentionData(data) {
      if (data) {
        //傷害險續保增額提醒
        if (data.injury_insurance && data.injury_insurance.length > 0) {
          this.injuryInsurance.data = data.injury_insurance.map(item => {
            let cesumi = item.cesumi || ""; // 保額單位
            return {
              apc_id: item.apc_id || "", //要保人ID
              policy_no: item.policy_no || "", //保單號碼
              renewal: item.renewal || "", //續保日
              prod_sname: item.prod_sname || "", //保險商品
              role_name: item.role_name || "", //被保人姓名
              rd_amt:
                item.rd_amt == undefined ? "" : item.rd_amt.toString() + cesumi, //保額
              rd_prem: item.rd_prem || "", //保費
              new_rd_amt:
                item.new_rd_amt == undefined
                  ? ""
                  : item.new_rd_amt.toString() + cesumi, //試算續保保額
              new_rd_prem: item.new_rd_prem || "", //試算續保保費
              deadline: item.deadline || "" //建議辦理期限
            };
          });
          this.attention.push(this.injuryInsurance);
        }
        //外溢保單資訊查詢
        if (data.spillover_policy && data.spillover_policy.length) {
          this.spilloverPolicy.data = data.spillover_policy;
          this.attention.push(this.spilloverPolicy);
        }
        //親疏等級
        if (data.cont_score) {
          let cont_score_name = '';
          switch (data.cont_score.cont_score) {
            case 'A':
              cont_score_name = '親疏等級 - 核心客戶';
              break;
            case 'B':
              cont_score_name = '親疏等級 - 經營中客戶';
              break;
            case 'C':
              cont_score_name = '親疏等級 - 疏遠客戶';
              break;
          }
          if (cont_score_name) {
            this.contScore.name = cont_score_name;
            this.attention.unshift(this.contScore);
          }
        }
      }
    },
    //開啟注意事項視窗
    openAttentionModal(attention) {
      if (attention.id == "CathayAppRecommend") {
        // 如果無ID 不送API
        if (this.$store.state.custInfo.ID && !(this.$store.state.custInfo.ID).includes('~') && !this.mmlUrl) {
          //取得會員/網路服務資格 (申辦項目)
          getCustInfo_MemberNetwork(this.$store.state.userInfo.id, this.$store.state.userInfo.id, this.$store.state.custInfo.ID, "").then(result => {
            if(result.header && result.header.status === '200'){
              this.setMemberNetworkItem(result.body.membernetworklist);
            }else{
              if(result.header && result.header.message) {
                this.$toast.info({title: result.header.message})
              } else {
                this.$toast.info({title: '查詢會員/網路服務資格失敗,請重新操作'})
              }
            }
          });
        }

        //網路服務推薦連結
        this.panelOpen("RecommandAppOpen");
      } else if (attention.id == "EldEvaluationForm") {
        //高齡投保評估量表
        this.panelOpen("EldEvaluationFormOpen");
      } else if (attention.id == "EldSolicitudeForm") {
        //高齡關懷包連結
        this.panelOpen("EldSolicitudeFormOpen");
      } else if (attention.id == "CathaySurvey") {
        //未拜訪回饋(問卷)
        this.selectedCustID = this.$store.state.custInfo.ID;
        this.surveySerNo = "001";
        this.panelOpen('surveyModalOpen');
      } else if (attention.id == "ContScore") {
        //親疏等級
        this.panelOpen("contScoreModalOpen");
      } else {
        this.selectAttention = attention.data;
        this.selectAttentionID = attention.id;
        this.selectAttentionName = attention.modalTitle;
        this.panelOpen('attentionModalOpen');
      }
    },
    //開啟加入至現有群組視窗
    addToCurrentGroup() {
      this.panelClose('confirmGroupModalOpen');
      this.panelOpen('addToGroupNewModalOpen');
    },
    //開啟成立新的群組視窗
    createNewGroup() {
      this.panelClose('confirmGroupModalOpen');
      this.panelOpen('groupNewModalOpen');
    },
    //開啟泰好客說明視窗
    openCathayCustInfoModal () {
      this.panelOpen('cathayCustInfoModalOpen');
    },
    //開啟投資風險屬性說明視窗
    openRiskAttributesModal () {
      this.panelOpen('riskAttributesModalOpen');
    },
    //開啟親疏等級問券視窗
    openSurveyModal () {
      this.selectedCustID = this.$store.state.custInfo.ID;
      this.surveySerNo = "003"; //TODO 備註:之後改成003，因為003的問券還沒做好
      this.panelOpen('surveyModalOpen');
    },
  },
  beforeMount () {
    let routeNumber = (this.$route.name.split(/-/g)).reverse()
    this.currentTab = Number(routeNumber[0])

    this.serviceItems = [
      this.serviceCHANGEONLINE,
      this.serviceFITBACK,
      this.servicePAYMENT_APPLY,
      this.serviceESERVER,
      this.servicePLCNOS,
      this.serviceSHOW_ECALL,
      this.servicePL_LOAN,
      this.serviceCLAIM_OFFSET_BILL,
      this.serviceFACE_STATUS,
    ]
  },
  mounted () {
    this.showDeleteConsumerTip();
    if (this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo) {
      this.initCustomerDetail1();
    }
    let version = this.iOSversion()
    if(version === 13) {
      //disableBodyScroll($("#customer-detail1-main div"));
    }
    localStorage.checkMvBack = true
    if (this.$store.state.userInfo.userType === 'box') {
      //接Box參數
      window.getCustInfoFromBox = (data) => {
        this.getCustInfoFromBox(data);
      };
      this.isReadyListenAppJS();
    }
    //disableBodyScroll($("div"));
    //enableBodyScroll($("main"));
    // setTimeout(() => {
    //   // get first api and change loading section 1
    //   this.loading_1 = false;
    // }, 3000)
    // setTimeout(() => {
    //   // get second api and change loading section 2
    //   this.loading_2 = false;
    // }, 6000)    
  }
}
</script>

<style lang="scss" scoped>
.boxPadding {
  padding-top: 0px !important;
}
.cathay-cust-info-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 0.5rem;
  margin-right: 0.5rem;
  font-family: inherit;
  line-height: 1.2;
}
.cathay-cust-info-title-circle {
  border-radius: 50%;
  width: 6px;
  height: 6px;
}

.cathay-cust-info-label {
  padding-left: 0.5rem;
  padding-right: 1.2rem;
}

.bg-green1 {
  background-color: rgb(0,128,0);
}

.bg-green2 {
  background-color: rgb(146,208,80);
}

.bg-gray {
  background-color: rgb(230,230,230);
}

.bg-orange1 {
  background-color: rgb(245, 136, 26);
}

.bg-orange2 {
  background-color: rgb(244, 177, 131);
}

.table-info {
  width: 90%;
  border-collapse: collapse;
  tbody {
    tr > td {
      font-size: 18px;
      padding-top: 1rem;
    }
    td > label {
      padding-left: 0.7rem;
    }
    td > span {
      border-radius: 50%;
      width: 36px;
      height: 36px;
      padding: 8px;
      color: #fff;
      text-align: center;
      font: 18px Arial, sans-serif;
      font-weight: 600;
    }
  }
}

</style>
